<template>
  <div class="pa-4">
    <h2 class="mb-3 text-center">
      {{ $t('servicesystem.loginform.text.validate_code') }}
    </h2>
    <p class="text-center">A one time validation code was sent to <b>{{ email }}</b>.<br>
      Please enter that code below to continue.
    </p>
    <p v-if="errorText" class="error--text text-center">{{ errorText }}</p>
    <v-otp-input v-model="computedOtp" :length="otpLength" :error-messages="errorText" @keypress="errorText = ''">
    </v-otp-input>
    <!-- 
    <p class="text-center mb-9">
      Did you not recive a code?
      <v-btn text style="text-transform: none; height: unset; min-width: unset;" class="pa-0"
        color="primary">Resend</v-btn>
    </p>
    -->

    <WideBtn :text="$t('servicesystem.common_objects.commonterms.validate')" color="var(--v-primary-base)"
      :disabled="!otpFilled" :loading="taskInProgress" @click="validateOtp()">
    </WideBtn>
    <WideBtn :text="$t('servicesystem.common_objects.commonterms.cancel')" color="var(--v-primary-base)"
      :disabled="taskInProgress" :filled="false" @click="$emit('cancel')">
    </WideBtn>
  </div>
</template>


<script>
import http from "@/api/client";
import WideBtn from "@/components/WideBtn.vue";

export default {
  name: "OTPContent",
  model: {
    prop: "otp",
    event: "change",
  },
  props: {
    email: String,
    otp: [String, Number],
  },
  components: {
    WideBtn
  },

  data() {
    return {
      otpLength: 6,
      valid: false,

      taskInProgress: false,
      errorText: "",
    };
  },

  methods: {
    requestOtp() {

    },

    validateOtp() {
      this.taskInProgress = true;
      this.errorText = "";
      http()
        .get(`/api2/Accounts/ValidateOtp`, { params: {email: this.email, code: this.computedOtp} })
        .then((response) => {
          if (response.data.Success) {
            this.$emit("next");
          }
          else {
            this.errorText = response.data.Message;
          }
        })
        .catch((error) => {
          console.error(error);
          if (error) {
            this.errorText = error.data.Message;
          }
          else {
            this.errorText = "An error occurred while validating the code.";
          }
        }).finally(() => {
          this.taskInProgress = false;
        });
    },
  },

  computed: {
    otpFilled() {
      return this.computedOtp.length === this.otpLength
    },

    computedOtp: {
      get() {
        return this.otp
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },

  watch: {
    otpFilled() {
      this.validateOtp();
    },
  },
};
</script>


<style lang="scss"></style>